import { Backdrop, Box, CircularProgress } from '@mui/material'
import { useEffect } from 'react'
import { styled } from 'styled-components'

import { Handler } from '../../helpers/typeHelper'
import { muiTheme } from '../../theme'
import { FlexBox } from '../Base/FlexBox'

interface SpinnerProps {
  open: boolean
}

const StyledBackdrop = styled(Backdrop)`
  z-index: ${muiTheme.zIndex.drawer + 1};
`

export const Spinner = ({ open }: SpinnerProps) => {
  return (
    <StyledBackdrop open={open}>
      <Box alignContent="center">
        <CircularProgress color="primary" />
      </Box>
    </StyledBackdrop>
  )
}

interface InlineSpinnerProps {
  size?: string
  className?: string
  mt?: number
  mb?: number
  styles?: string
  color?: 'inherit' | 'primary' | 'secondary'
  executeOnLoad?: Handler
}

export const InlineSpinner = ({
  size,
  className,
  mt,
  mb,
  styles,
  color,
  executeOnLoad,
}: InlineSpinnerProps) => {
  useEffect(() => {
    executeOnLoad?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FlexBox
      alignItems="center"
      justifyContent="center"
      className={className}
      mt={mt}
      mb={mb}
      styles={styles}
    >
      <CircularProgress color={color || 'primary'} size={size || '2em'} />
    </FlexBox>
  )
}
